import { render, staticRenderFns } from "./AccommodationLetters.vue?vue&type=template&id=23d65301&scoped=true&"
import script from "./AccommodationLetters.vue?vue&type=script&lang=js&"
export * from "./AccommodationLetters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d65301",
  null
  
)

export default component.exports